































import { Component, Prop, Vue } from 'vue-property-decorator';
import MyAlpacas from '@/components/MyAlpacas.vue';
import AlpacaBtn from '@/components/AlpacaBtn.vue';
import { Alpaca } from '@/backend/type';

@Component({
  components: {
    MyAlpacas,
    AlpacaBtn,
  },
})
export default class SelectBreedingPopup extends Vue {
  @Prop({
    type: Boolean,
    required: true,
    default: false,
  })
  public value!: boolean;

  @Prop({
    type: String,
    required: true,
  })
  public parent!: 'sire' | 'matron';

  @Prop({
    type: Number,
    required: false,
  })
  public sireId!: number;

  @Prop({
    type: Number,
    required: false,
  })
  public matronId!: number;

  public curTab: 'myAlpacas' | 'otherAlpacas' = 'myAlpacas';

  get isMyAlpacasTab() {
    return this.curTab === 'myAlpacas';
  }

  get isOtherAlpacasTab() {
    return this.curTab === 'otherAlpacas';
  }

  get isBSC() {
    return !!process.env.VUE_APP_BSC;
  }

  public changeState(state: boolean) {
    this.$emit('input', state);
  }

  public close() {
    this.changeState(false);
  }

  public clickAlpacaCard(alpaca: Alpaca) {
    this.$emit('clickAlpacaCard', {alpaca, parent});
    this.close();
  }

  public changeTab(tab: 'myAlpacas' | 'otherAlpacas') {
    this.curTab = tab;
  }
}
